export default __webpack_public_path__ + "static/media/gitorg.fc724c84.png";